import React from 'react';
import forms from '../../cms/forms.json';
import FormComponent from './FormComponent';
import { hydrateFormConfig } from '../../utils/hydrateFormConfig';
import { submitSiteForm } from '../../utils/submitSiteForm';
import { isSeasonalNoticeActive } from '../../utils/seasonalNotice';
import { renderSeasonalNotice } from '../../utils/renderSeasonalNotice';

/**
 * Renders a CMS-backed modal form by formKey (e.g. get-connected, schedule-tour).
 */
const DynamicSiteForm = ({ formKey, onClose, maxWidth = '700px', inline = false }) => {
  const formDef = forms[formKey];

  if (!formDef || !formDef.enabled) {
    return null;
  }

  const formConfig = hydrateFormConfig(formDef);
  if (!formConfig) return null;

  if (isSeasonalNoticeActive(formDef.seasonalNotice)) {
    formConfig.seasonalNotice = renderSeasonalNotice(formDef.seasonalNotice);
  }

  const handleSubmit = async (formData) => {
    return submitSiteForm(formDef.emailjsHandler, formData, formDef, formKey);
  };

  return (
    <FormComponent
      isOpen={true}
      onClose={onClose}
      onSubmit={handleSubmit}
      formConfig={formConfig}
      maxWidth={maxWidth}
      inline={inline}
    />
  );
};

export default DynamicSiteForm;

/**
 * Whether a form key exists and is enabled in CMS.
 */
export function isSiteFormEnabled(formKey) {
  const formDef = forms[formKey];
  return formDef && formDef.enabled;
}
